<template>
  <div
    class="calciatore"
    :class="calciatoreClass"
    @click="selected"
    v-ripple="ripple"
  >
    <!-- <v-list-item @click="selected"> -->
    <!-- <span class="Ruolo3">{{ ruolo3(thisCalciatore.ID_Ruolo) }}</span> -->
    <div class="d-flex flex-column">
      <div
        class="calciatore-maglia"
        :style="{
          backgroundImage: magliaClub,
        }"
      >
        <div v-if="!hideImages" class="calciatore-sx">
          <div class="imgCalciatore without-ms">
            <div class="imgContainer imgContainer-ruolo_">
              <div
                v-if="Config.AVATAR_OR_FLAG == 'avatar'"
                class="img"
                :key="thisCalciatore.nid"
                :style="{
                  backgroundImage: `url(${
                    thisCalciatore.imgCalciatore
                      ? thisCalciatore.imgCalciatore
                      : Config.PUBLIC_DIR +
                        '/schede_calciatori/avatar/default/avatar_club_' +
                        thisCalciatore.ID_Club +
                        '.png'
                  })`,
                }"
              ></div>

              <div
                v-if="Config.AVATAR_OR_FLAG == 'flag'"
                class="img flag"
                :key="thisCalciatore.nid"
                :style="{
                  backgroundImage: `url(${
                    Config.PUBLIC_DIR +
                    '/clubs/flags/flag_' +
                    thisCalciatore.ID_Club +
                    '.png'
                  })`,
                }"
              ></div>
            </div>
          </div>
        </div>
        <div class="calciatore-content">
          <div class="calciatore-content-sup">
            {{ thisCalciatore.calciatore }}
            <!-- <v-icon
              v-if="scartato"
              outlined
              x-small
              right
              color="colorScartati"
            >
              visibility_off
            </v-icon> -->
          </div>
          <div class="calciatore-content-inf">
            <span class="" v-if="thisCalciatore.ID_Club">
              {{ thisCalciatore.nomeClub }}
            </span>
            <span class="ruoli-mantra" v-if="mantra">
              <span
                class="ml-1"
                :class="{
                  ['ruolo-mantra' + mantra_id]: true,
                }"
                v-for="mantra_id in thisCalciatore.mantra_ids"
                :key="mantra_id"
                >{{ ruoloMantra(mantra_id) }}</span
              >
            </span>
          </div>
        </div>
        <div class="calciatore-dx">
          <!-- prezzo -->
          <span v-if="cal && cal.p != 0" class="pagato mr-3">{{ cal.p }}</span>
          <!-- modifica/elimina -->
          <div
            v-if="!hideEditRemove"
            class="d-flex flex-column-reverse justify-center"
          >
            <!-- elimina -->
            <v-btn
              v-if="admin && cal && cal.i == 0"
              icon
              x-small
              depressed
              color="navy darken-2"
              @click="removeCb"
            >
              <v-icon small>close</v-icon>
            </v-btn>
            <!-- modifica -->
            <v-btn
              v-if="admin && cal && cal.i == 0"
              icon
              x-small
              depressed
              color="navy darken-2"
              @click="editCb"
            >
              <v-icon small>mode_edit</v-icon>
            </v-btn>
          </div>

          <!-- quotazione -->
          <span class="Quotazione" v-if="showQuotazione">
            Q {{ thisCalciatore.quotazione }}</span
          >

          <!-- riabilita -->
          <v-btn
            v-if="showButtonsScartaRiabilita && scartato"
            x-small
            depressed
            rounded
            outlined
            class="cyan white--text ml-4"
            @click="removeScartato"
            >Riabilita</v-btn
          >
          <v-btn
            v-else-if="showButtonsScartaRiabilita && !scartato"
            x-small
            depressed
            rounded
            outlined
            class="ml-4"
            @click="scartaCalciatore"
            >Scarta</v-btn
          >

          <!-- main status -->
          <div class="mainStatusPlaceholder" v-if="showMainStatus">
            <main-status :ms="thisCalciatore.ms"></main-status>
          </div>
        </div>
      </div>
      <div v-if="showStats && hasStats">
        <div class="calciatore-stats" v-if="thisCalciatore.ID_Ruolo == 1">
          <span class="label"><v-icon> fa-user </v-icon></span>
          <span class="value">{{ presenze }}</span>

          <span class="label"><v-icon> fa-futbol-o </v-icon></span>
          <span class="value">{{ golSu }}</span>

          <span class="label"
            ><v-img
              class="rigori"
              :src="firebase_host + '/static/img/rigPa.png'"
            ></v-img
          ></span>
          <span class="value">{{ rigPa }}</span>

          <span class="label"><v-icon> fa-star </v-icon></span>
          <span class="value">{{ pi }}</span>

          <span class="label"
            ><v-img
              class="cartellini"
              :src="firebase_host + '/static/img/cartellini.png'"
            ></v-img
          ></span>
          <span class="value">{{ cartellini }}</span>

          <span class="label">MV</span>
          <span class="value">{{ mv }}</span>

          <span class="label">FM</span>
          <span class="value">{{ fm }}</span>
        </div>
        <!-- calciatore di movimento -->
        <div class="calciatore-stats" v-else>
          <span class="label"><v-icon> fa-user </v-icon></span>
          <span class="value">{{ presenze }}</span>

          <span class="label"><v-icon> fa-futbol-o </v-icon></span>
          <span class="value">{{ gol }}</span>

          <span class="label"
            ><v-img
              class="rigori"
              :src="firebase_host + '/static/img/rig.png'"
            ></v-img
          ></span>
          <span class="value">{{ rigori }}</span>

          <span class="label"
            ><v-img
              class="assist"
              :src="firebase_host + '/static/img/assist.png'"
            ></v-img
          ></span>
          <span class="value">{{ ass }}</span>

          <span class="label"
            ><v-img
              class="cartellini"
              :src="firebase_host + '/static/img/cartellini.png'"
            ></v-img
          ></span>
          <span class="value">{{ cartellini }}</span>

          <span class="label">MV</span>
          <span class="value">{{ mv }}</span>
          <span class="label">FM</span>
          <span class="value">{{ fm }}</span>
        </div>
      </div>
    </div>
    <!-- </v-list-item> -->
  </div>
</template>

<script>
import Vuex from "vuex";

import db from "../../js/db";
import mixins from "../../js/mixins";
import Config from "../../../config-app/config";
import MainStatus from "./MainStatus";

export default {
  name: "calciatore",
  mixins: [mixins],
  components: {
    MainStatus,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    showQuotazione: {
      type: Boolean,
      default: false,
    },
    showMainStatus: {
      type: Boolean,
      default: false,
    },
    showStats: {
      type: Boolean,
      default: false,
    },
    showButtonsScartaRiabilita: {
      type: Boolean,
      default: false,
    },
    hideImages: {
      type: Boolean,
    },
    hideEditRemove: {
      type: Boolean,
    },
    scartato: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Function,
      default: function () {},
    },
    remove: {
      type: Function,
      default: function () {},
    },
    edit: {
      type: Function,
      default: function () {},
    },
    remove_scartato: {
      type: Function,
      default: function () {},
    },
    cal: {
      type: Object,
      default: null,
    },
    textScuro: {
      type: Boolean,
    },
    bgChiaro: {
      type: Boolean,
    },
    ripple: {
      type: Boolean,
    },
    bgAsRuolo: {
      type: Boolean,
    },
    borderAsRuolo: {
      type: Boolean,
    },
    gradiented: {
      type: Boolean,
    },
    ruoloRight: {
      type: Boolean,
    },
  },
  data() {
    return {
      firebase_host: Config.FIREBASE_HOST,
    };
  },
  mounted() {},
  computed: {
    hasStats() {
      return (
        this.thisCalciatore.hasOwnProperty("stats") &&
        this.thisCalciatore.stats.hasOwnProperty(this.annoStats) &&
        this.thisCalciatore.stats[this.annoStats].hasOwnProperty(this.homeAway)
      );
    },
    presenze() {
      const presenze =
        this.thisCalciatore.stats[this.annoStats][this.homeAway].presenze;
      if (presenze == 0) {
        return "-";
      }
      return presenze;
    },
    gol() {
      const golFa =
        this.thisCalciatore.stats[this.annoStats][this.homeAway].golFa;
      const rigFa =
        this.thisCalciatore.stats[this.annoStats][this.homeAway].rigFa;
      if (golFa + rigFa == 0) {
        return "-";
      }
      return golFa + rigFa;
    },
    golSu() {
      const golSu =
        this.thisCalciatore.stats[this.annoStats][this.homeAway].golSu;
      if (golSu == 0) {
        return "-";
      }
      return golSu;
    },
    pi() {
      const pi = this.thisCalciatore.stats[this.annoStats][this.homeAway].pi;
      if (pi == 0) {
        return "-";
      }
      return pi;
    },
    rigPa() {
      const rigPa =
        this.thisCalciatore.stats[this.annoStats][this.homeAway].rigPa;
      if (rigPa == 0) {
        return "-";
      }
      return rigPa;
    },
    cartellini() {
      const amm = this.thisCalciatore.stats[this.annoStats][this.homeAway].amm;
      const esp = this.thisCalciatore.stats[this.annoStats][this.homeAway].esp;
      if (amm + esp == 0) {
        return "-";
      }
      return amm + esp;
    },
    ass() {
      const ass = this.thisCalciatore.stats[this.annoStats][this.homeAway].ass;
      if (ass == 0) {
        return "-";
      }
      return ass;
    },
    rigori() {
      const rigTot =
        this.thisCalciatore.stats[this.annoStats][this.homeAway].rigFa +
        this.thisCalciatore.stats[this.annoStats][this.homeAway].rigSb;

      if (rigTot == 0) {
        return "-/-";
      }
      return (
        this.thisCalciatore.stats[this.annoStats][this.homeAway].rigFa +
        "/" +
        rigTot
      );
    },
    mv() {
      const mv = this.thisCalciatore.stats[this.annoStats][this.homeAway].mv;
      if (mv == 0) {
        return "-";
      }
      return mv;
    },
    fm() {
      const fm = this.thisCalciatore.stats[this.annoStats][this.homeAway].fm;
      if (fm == 0) {
        return "-";
      }
      return fm;
    },
    thisCalciatore() {
      return this.calciatori[this.id];
    },
    magliaClub() {
      if (this.hideImages) {
        return "";
      } else {
        return `url(${
          this.thisCalciatore.ID_Club
            ? Config.PUBLIC_DIR +
              "/clubs/maglie/400x400/ID_Anno_" +
              Config.ID_ANNO_MAGLIE +
              "/img_scheda_club_" +
              this.thisCalciatore.ID_Club +
              ".png"
            : ""
        })`;
      }
    },
    calciatoreClass() {
      return {
        iniziale: this.cal && this.cal.i == 1,
        bgAsRuolo: this.bgAsRuolo,
        bgChiaro: this.bgChiaro,
        textScuro: this.textScuro,
        borderAsRuolo: this.borderAsRuolo,
        gradiented: this.gradiented,
        hasRipple: this.ripple,
        ["ruolo-right"]: this.ruoloRight,
        ["ruolo_" + this.thisCalciatore.ID_Ruolo]: true,
      };
    },

    colorScartati() {
      return this.scuro ? "primary" : "text";
    },
    ...Vuex.mapGetters(["calciatori", "annoStats", "homeAway"]),
  },
  methods: {
    removeCb() {
      if (this.isAstaInCorso) {
        db.emit(
          "swalAstaInCorso",
          "E' possibile rimettere calciatori tra gli svincolati solo dopo aver fermato l'asta"
        );
      } else {
        this.remove();
      }
    },
    editCb() {
      if (this.isAstaInCorso) {
        db.emit(
          "swalAstaInCorso",
          "E' possibile modificare il prezzo di acquisto di un calciatore solo dopo aver fermato l'asta"
        );
      } else {
        this.edit();
      }
    },
    removeScartato() {
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }
      db.rimuoviCalciatoreScartato(this.id).then(
        this.astaLogRemoveScartato(this.id)
      );
    },
    scartaCalciatore() {
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }
      db.scartaCalciatore(this.id).then(
        this.astaLogScartato(this.thisCalciatore.id)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";
.calciatore {
  list-style-type: none;
  margin: 5px 15px;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: rgb(255 255 255 / 12%);
  box-shadow: none;

  .calciatore-content-sup {
    color: white;
  }
  .calciatore-content-inf {
    color: rgb(255 255 255 / 75%);
  }

  &.bgChiaro {
    background: white;
    box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 12%);
  }

  &.textScuro {
    .calciatore-content-sup {
      color: var(--v-text-base);
    }
    .calciatore-content-inf {
      color: var(--v-text-lighten1);
    }
  }

  &.bgAsRuolo {
    &.ruolo_1 {
      background-color: #fc9922;
      &.gradiented {
        background: linear-gradient(0deg, #fc9922, #fcc022);
      }
    }
    &.ruolo_2 {
      background-color: #2196f3;

      &.gradiented {
        background: linear-gradient(0deg, #1d83d4, #40a4f4);
      }
    }
    &.ruolo_3 {
      background-color: #ec553a;
      &.gradiented {
        background: linear-gradient(0deg, #d9543c, #ff6347);
      }
    }
    &.ruolo_4 {
      background-color: #89ba26;
      &.gradiented {
        background: linear-gradient(0deg, #89ba26, #9fd92a);
      }
    }
  }

  &.borderAsRuolo {
    border-left-width: 4px;
    border-left-style: solid;
    border-radius: 0 4px 4px 0;
    &.ruolo_1 {
      border-color: rgb(252 153 34 / 60%);
    }
    &.ruolo_2 {
      border-color: rgb(33 150 243 / 60%);
    }
    &.ruolo_3 {
      border-color: rgb(225 48 17 / 63%);
    }
    &.ruolo_4 {
      border-color: rgb(137 186 38 / 50%);
    }
  }

  .calciatore-maglia {
    background-repeat: no-repeat;
    background-size: 65px;
    padding: 0;
    align-items: center;
    display: flex;
    flex: 1 1 100%;
    min-height: 48px;
    outline: none;
    position: relative;
  }

  .Ruolo3 {
    display: none;
    // display: inline-block;
    position: absolute;
    top: -4px;
    left: -13px;
    font-weight: bold;
    font-size: 9px;
    color: rgba(255, 255, 255, 0.75);
    /* background: var(--v-navy-darken1); */
    border-radius: 2px;

    padding: 1px 4px;
  }

  &.ruolo-right {
    .Ruolo3 {
      right: -4px;
      left: inherit;
      background: var(--v-navy-base);
    }
  }
  &.no-ruolo {
    .Ruolo3 {
      display: none;
    }
  }
  .calciatore-sx {
    margin-right: 5px;
    vertical-align: middle;
  }
  .calciatore-sx .imgCalciatore {
    margin: 6px 0 1px 40px;
  }

  .calciatore-content {
    display: flex;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    line-height: 1.25em;
    white-space: normal;
  }
  .calciatore-content-sup {
    font-weight: bold;
    text-transform: uppercase;
    text-align: left;
    display: flex;
    align-items: center;
  }
  .calciatore-content-inf {
    text-align: left;
    margin-top: 5px;
  }
  .calciatore-dx {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.calciatore span.pagato {
  color: goldenrod;
  font-weight: bold;
  font-size: 14px;
  background: var(--v-navy-darken2);
  padding: 0px 10px;
  border-radius: 2px;
  font-family: "Roboto", "Lato";
  min-width: 38px;
  text-align: center;
}

.calciatore .Ruolo {
  margin-right: 3px;
}

.calciatore-stats {
  margin-top: 5px;
  display: flex;
  justify-content: space-evenly;
  .label {
    color: var(--v-navy-darken2);
    font-size: 11px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    i {
      color: var(--v-navy-darken2);
      font-size: 13px;
    }
    .rigori {
      width: 20px;
    }
    .assist {
      width: 15px;
    }
    .cartellini {
      width: 15px;
    }
  }
  .value {
    color: var(--v-navy-lighten5);
    margin: 0px 3px;
    font-weight: bold;
    font-size: 12px;
  }
}

.mainStatusPlaceholder {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  padding: 5px;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.hasRipple {
  cursor: pointer;
}

// .calciatore.iniziale .calciatore-dx {
//   opacity: 0.5;
// }
</style>
